import {Issue} from "../domain/entities/issue.entity";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {DeleteIssueCommand} from "../commands/delete-issue.command";

@injectable()
@transformer({
    source: DeleteIssueCommand,
    target: `dto`
})
export class DeleteIssueCommandToDtoTransformer extends AbstractCommandToDtoTransformer<string> {

    protected async toDTO(issue: Issue): Promise<DataTransferObject> {
        return Promise.resolve(<DataTransferObject>{ uid: issue.uid });
    }

}